import React, { useContext, useEffect, useState } from 'react';
import ProposalNavBar from './components/ProposalNavBar';
import StatusBar from './components/StatusBar';
import dummyMap from '../../../../../assets/images/map-dummy2.png';
import SolarCell from '../../../../../resources/images/SolarCell';
import DayLightLogo from '../../../../../resources/images/DayLightLogo';
import RadioButtonTab from '../../../../../components/RadioButton/RadioButtonTab';
import Toggle from '../../../../../components/Toggle/Toggle';
import Dropdown from '../../../../../components/Dropdown/Dropdown';
import Dropdown2 from '../../../../../components/Dropdown/Dropdown2';
import GoogleSunroofMap from '../../../../../components/GoogleSunroofMap/GoogleSunroofMap';
import { StepperContext } from '../../../../../providers/stepper.provider';
import { calculatePMT, calculateSavings } from '../../../../../utils/utils';
import {
  GET_PROPOSAL_BOOKING_PAYMENT_URL,
  UPDATE_SOLAR_PROPOSAL_MUTATION
} from '../../../../../GraphQL/Mutations';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../../providers/auth.provider';
import Counter from '../../../../../components/Counter/Counter';
import { StripeContext } from '../../../../../providers/stripe.provider';
import dayLightNewLogo from '../../../../../assets/images/daylight-new-logo.png';

const options = [{ id: 1, value: '1', name: 'Premium Standard' }];

const Proposal = ({ viewOnly = false }) => {
  const navigate = useNavigate();
  const [paymentOption, setPaymentOption] = useState('Cash');
  const [isChecked, setIsChecked] = useState(false);
  const [isTempraryOffEditing, setIsTempraryOffEditing] = useState(true);
  const { requestTokenResponse } = useContext(AuthContext);

  const {
    solarInquiryData,
    setSolarInquiryData,
    solarConfiguration,
    isExistingProposal,
    setProductQuantity,
    proposalId,
    updatedCalculationBasedOnBattery,
    setUpdatedCalculationBasedOnBattery,
    solarProposalAdditionalDetails,
    setSolarProposalAdditionalDetails
  } = useContext(StepperContext);

  const { bookingAmount } = useContext(StripeContext);

  // For monthly Rate
  const FINANCE_RATE = solarConfiguration && parseFloat(solarConfiguration.financeRate); // 2.99%;
  const TERM_IN_YEARS = solarConfiguration && parseInt(solarConfiguration.termInYears);
  const PER_BATTERY_COST =
    solarConfiguration && parseFloat(solarConfiguration.batteryCostPerBattery);
  const PER_BATTERY_PAYMENT =
    solarConfiguration && parseFloat(solarConfiguration.batteryPaymentPerBattery);
  const BATTERY_FEDERAL_INCENTIVE =
    solarConfiguration && parseFloat(solarConfiguration.batteryItcRate); // 30%
  const PER_BATTERY_CASHBACK_RATE =
    solarConfiguration && parseFloat(solarConfiguration.daylightCashbackRate); // 12.50%

  const INFLATION_RATE_PERCENTAGE =
    solarConfiguration && parseFloat(solarConfiguration.inflationRate); // increase by 3% per year
  const SOLAR_DEGRADATION_FACTOR_PERCENTAGE =
    solarConfiguration && parseFloat(solarConfiguration.solarDegradationFactor); // decrease 0.05% per year
  const TOTAL_YEARS = 25;
  const DAYLIGHT_CASHBACK_PPW =
    solarConfiguration && parseFloat(solarConfiguration.daylightCashbackPpw);
  const SYSTEM_PRICE_RATE_PPW =
    solarConfiguration && parseFloat(solarConfiguration.systemPriceRate);
  const FEDERAL_ITC_RATE = solarConfiguration && parseFloat(solarConfiguration.federalItcRate); // 30%;

  const [updateSolarProposalMutation, { loading: updateSolarProposalMutationLoading }] =
    useMutation(UPDATE_SOLAR_PROPOSAL_MUTATION);
  const [getProposalBookingPaymentUrl, { loading: getProposalBookingPaymentUrlLoading }] =
    useMutation(GET_PROPOSAL_BOOKING_PAYMENT_URL);

  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      updateBatterySlider(1, requestTokenResponse.token);
    } else {
      updateBatterySlider(0, requestTokenResponse.token);
    }
    setIsChecked(e.target.checked);
  };

  const handleBatteryQuantityCounter = async (quantity) => {
    await updateProposalNew({
      addressInput: {
        id: proposalId.customerAddressId
      },
      solarProposalInput: {
        id: proposalId.solarProposalId,
        batteryQuantity: quantity
      }
    });
  };

  const handleSolarPanelCounter = async (quantity) => {
    await updateProposalNew({
      addressInput: {
        id: proposalId.customerAddressId
      },
      solarProposalInput: {
        id: proposalId.solarProposalId,
        numberOfPanels: String(quantity)
      }
    });
  };

  const updateSolarProposalValues = async (existingSolarResponse) => {
    const existingSolarRes = existingSolarResponse.data.updateSolarProposalV2.success;
    const updatedSolarInquiryData = {
      address: existingSolarRes.customerAddress.address,
      city: existingSolarRes.customerAddress.city,
      state: existingSolarRes.customerAddress.state,
      zipCode: existingSolarRes.customerAddress.zipCode,
      email: existingSolarRes.customerAddress.email,
      electricityCost: parseFloat(existingSolarRes.customerAddress.electricityCost),
      energyBillSaving: 1.4,
      monthlyEnergyCost: existingSolarRes.customerAddress.avgMonthlyElectricityCost,
      earnCashbackUpTo: parseInt(existingSolarRes.earnCashbackUpTo),
      treesPlanted: parseInt(existingSolarRes.treesPlanted),
      wattCost: existingSolarRes.wattCost,
      sizeSmoothing: parseFloat(existingSolarRes.sizeSmoothing),
      systemPrice: parseInt(existingSolarRes.systemCost),
      batteryQuantity: existingSolarRes.batteryQuantity,
      addressLatLng: {
        lat: Number(existingSolarRes.customerAddress.latitude),
        lng: Number(existingSolarRes.customerAddress.longitude)
      },
      phoneNumber: existingSolarRes.customerAddress.phoneNumber,
      progress: existingSolarRes.customerAddress.progress,
      heatPump: existingSolarRes.heatPump,
      energyEfficiency: existingSolarRes.energyEfficiency,
      sunroofImageId: '',
      formatedAddress: solarInquiryData.formatedAddress
    };

    const updatedAdditionalValues = {
      batteryBrand: existingSolarRes.batteryBrand,
      inverter: existingSolarRes.inverter,
      solarOffset: parseInt(existingSolarRes.solarOffset),
      systemCost: parseInt(existingSolarRes.systemCost),
      federalItc: parseInt(existingSolarRes.federalItc),
      netSystemCost: parseInt(existingSolarRes.netSystemCost),
      wattCost: Number(existingSolarRes.wattCost),
      financeSystemCost: parseFloat(existingSolarRes.financeSystemCost),
      monthlyInstallment: parseFloat(existingSolarRes.monthlyInstallment),
      monthlyEnergyCost: parseFloat(existingSolarRes.monthlyEnergyCost),
      energyBillingSaving: parseFloat(existingSolarRes.energyBillingSaving),
      financeNetSystemCost: parseFloat(existingSolarRes.financeNetSystemCost),
      financeWattCost: parseFloat(existingSolarRes.financeWattCost),
      estimatedAnnualIncrease: parseInt(existingSolarRes.estimatedAnnualIncrease),
      numberOfPanels: parseInt(existingSolarRes.numberOfPanels),
      savingOver25Years: parseInt(existingSolarRes.savingOver25Years),
      srecPreBuyDiscount: parseInt(existingSolarRes.srecPreBuyDiscount),
      federalLocalStateIncentives: parseInt(existingSolarRes.federalLocalStateIncentives)
    };

    setSolarProposalAdditionalDetails({
      ...updatedAdditionalValues
    });

    setSolarInquiryData({ ...updatedSolarInquiryData });
  };

  const updateProposalNew = async (data) => {
    try {
      const solarInquiryResponse = await updateSolarProposalMutation({
        variables: data
      });
      await updateSolarProposalValues(solarInquiryResponse);

      return solarInquiryResponse;
    } catch (error) {
      console.log(error);
    }
  };

  const annualEnergyUsage = (electricityRate, monthlyEnergyCost) => {
    const annualEnergyUsage = Math.ceil(monthlyEnergyCost / electricityRate) * 12;
    return annualEnergyUsage;
  };

  const calculateBatteryCost = (quantity) => {
    return quantity * PER_BATTERY_COST + quantity * PER_BATTERY_PAYMENT;
  };

  const calculateBatteryCashBack = (quantity) => {
    return quantity * ((PER_BATTERY_COST * PER_BATTERY_CASHBACK_RATE) / 100);
  };

  const updateBatterySlider = async (quantity, proposalIdObj = proposalId) => {
    const fedralIncentiveForBattery =
      (BATTERY_FEDERAL_INCENTIVE / 100) * quantity * PER_BATTERY_COST;

    setProductQuantity(quantity);
    setUpdatedCalculationBasedOnBattery({
      ...solarInquiryData,
      earnCashbackUpTo: solarInquiryData.earnCashbackUpTo + calculateBatteryCashBack(quantity),
      systemPrice: solarInquiryData.systemPrice + calculateBatteryCost(quantity),
      fedralITCAmount:
        solarInquiryData.fedralITCAmount +
        (BATTERY_FEDERAL_INCENTIVE / 100) * quantity * PER_BATTERY_COST,
      netSolarSystemPrice:
        solarInquiryData.netSolarSystemPrice +
        quantity * PER_BATTERY_COST -
        (BATTERY_FEDERAL_INCENTIVE / 100) * quantity * PER_BATTERY_COST +
        quantity * PER_BATTERY_PAYMENT -
        calculateBatteryCashBack(quantity),
      savingOver25Years: parseInt(
        (
          calculateSavings(
            SOLAR_DEGRADATION_FACTOR_PERCENTAGE,
            INFLATION_RATE_PERCENTAGE,
            TOTAL_YEARS,
            solarInquiryData.electricityCost,
            annualEnergyUsage(solarInquiryData.electricityCost, solarInquiryData.monthlyEnergyCost)
          ) -
          (solarInquiryData.netSolarSystemPrice +
            quantity * PER_BATTERY_COST -
            (BATTERY_FEDERAL_INCENTIVE / 100) * quantity * PER_BATTERY_COST +
            quantity * PER_BATTERY_PAYMENT -
            calculateBatteryCashBack(quantity))
        ).toFixed(0)
      ),
      batteryQuantity: quantity,
      progress: 'customDesignStep'
    });

    const updateProposal = async (data, proposalIdObj = proposalId) => {
      try {
        const solarInquiryResponse = await updateSolarProposalMutation({
          variables: {
            addressInput: {
              id: proposalIdObj.customerAddressId,
              firstName: solarInquiryData.firstName,
              lastName: solarInquiryData.lastName,
              address: solarInquiryData.address,
              city: solarInquiryData.city,
              state: solarInquiryData.state,
              zipCode: solarInquiryData.zipCode,
              phoneNumber: solarInquiryData.phoneNumber,
              longitude: solarInquiryData.addressLatLng.lng,
              latitude: solarInquiryData.addressLatLng.lat,
              electricityCost: solarInquiryData.electricityCost,
              avgMonthlyElectricityCost: parseFloat(solarInquiryData.monthlyEnergyCost),
              progress: data.progress,
              onHome: solarInquiryData.onHome
            },
            solarProposalInput: {
              id: proposalIdObj.solarProposalId,
              earnCashbackUpTo: data.earnCashbackUpTo,
              estSolarSystemSizeKw: data.estSolarSystemSizekW,
              federalItc: parseFloat(data.fedralITCAmount.toFixed(2)),
              savingOver25Years: data.savingOver25Years,
              sizeSmoothing: data.sizeSmoothing,
              treesPlanted: data.treesPlanted,
              wattCost: data.wattCost,
              systemCost: parseFloat(data.systemPrice.toFixed(2)),
              netSystemCost: parseFloat(data.netSolarSystemPrice.toFixed(2)),
              batteryQuantity: data.batteryQuantity
            }
          }
        });

        return solarInquiryResponse;
      } catch (error) {
        console.log(error);
      }
    };

    const updatedSolarInquiry = await updateProposal(
      {
        ...solarInquiryData,
        earnCashbackUpTo: solarInquiryData.earnCashbackUpTo + calculateBatteryCashBack(quantity),
        systemPrice: solarInquiryData.systemPrice + calculateBatteryCost(quantity),
        fedralITCAmount:
          solarInquiryData.fedralITCAmount +
          (BATTERY_FEDERAL_INCENTIVE / 100) * quantity * PER_BATTERY_COST,
        netSolarSystemPrice:
          solarInquiryData.netSolarSystemPrice +
          quantity * PER_BATTERY_COST -
          (BATTERY_FEDERAL_INCENTIVE / 100) * quantity * PER_BATTERY_COST +
          quantity * PER_BATTERY_PAYMENT -
          calculateBatteryCashBack(quantity),

        savingOver25Years: parseInt(
          (
            calculateSavings(
              SOLAR_DEGRADATION_FACTOR_PERCENTAGE,
              INFLATION_RATE_PERCENTAGE,
              TOTAL_YEARS,
              solarInquiryData.electricityCost,
              annualEnergyUsage(
                solarInquiryData.electricityCost,
                solarInquiryData.monthlyEnergyCost
              )
            ) -
            (solarInquiryData.netSolarSystemPrice +
              quantity * PER_BATTERY_COST -
              (BATTERY_FEDERAL_INCENTIVE / 100) * quantity * PER_BATTERY_COST +
              quantity * PER_BATTERY_PAYMENT -
              calculateBatteryCashBack(quantity))
          ).toFixed(0)
        ),
        batteryQuantity: quantity,
        progress: 'customDesignStep'
      },
      proposalIdObj
    );

    return updatedSolarInquiry;
  };

  const handleStripeCheckout = async () => {
    try {
      const proposalBookingPaymentUrl = await getProposalBookingPaymentUrl({
        variables: {
          solarProposalId: proposalId.solarProposalId
        }
      });
      const paymentUrl = proposalBookingPaymentUrl.data.getProposalBookingPaymentUrl.url;
      return window.open(paymentUrl, '_blank');
    } catch (error) {}
  };

  const handleScheduleConsultation = async () => {
    const meetingLink =
      'https://meetings-na2.hubspot.com/victor-martinez?uuid=245fb32c-b412-4d9a-9889-c670e75d1920';
    window.open(meetingLink, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    if (!(solarInquiryData && solarInquiryData.address && proposalId && solarConfiguration)) {
      if (!viewOnly) {
        window.location.href = '/';
      }
    }
  }, []);

  return (
    <div className="pb-[120px]">
      <div className="max-w-[1178px] mx-auto mt-[18px]">
        <div className="ml-2">
          <div className="sm:[&>svg]:w-auto [&>svg]:w-[150px] h-auto">
            <DayLightLogo />
          </div>
        </div>
        <div className="flex flex-col justify-between mt-3 sm:flex-row">
          <div className="sm:max-w-[40%] w-[96%] ml-[8px] xl:mr-[32px] mr-[8px]">
            <div className="flex flex-col gap-[10px] mb-[20px]">
              <span className="text-[24px] font-forma-djr-mono-regular leading-[32px] text-primary_black opacity-30">
                {[
                  solarInquiryData.address,
                  solarInquiryData.city,
                  solarInquiryData.state,
                  solarInquiryData.zipCode
                ]
                  .filter(Boolean)
                  .join(', ')}
              </span>
            </div>

            <div className="max-w-[100%] h-[486px] mb-[20px]">
              <GoogleSunroofMap
                lat={solarInquiryData.addressLatLng.lat}
                lng={solarInquiryData.addressLatLng.lng}
              />
            </div>

            <div className="flex flex-col justify-between items-center rounded-[8px] border-[1px] border-solid border-primary_black font-forma-djr-display-medium">
              <ul className={`text-primary_black w-full p-4`}>
                <li className="flex flex-row justify-between items-center mb-[15px] ">
                  <p className="text-[16px] leading-[24px] font-forma-djr-display-medium">
                    Estimated annual production
                  </p>
                  <span className="text-[18px] leading-[18px] font-forma-djr-display-medium">
                    {solarProposalAdditionalDetails.estimatedAnnualIncrease.toLocaleString('en-US')}
                    kWh
                  </span>
                </li>
                <li className="flex flex-row justify-between items-center mb-[15px] ">
                  <p className="text-[16px] leading-[24px] font-forma-djr-display-medium">
                    Number of solar panels
                  </p>
                  <span className="text-[18px] leading-[18px] font-forma-djr-display-medium">
                    {!viewOnly && !isTempraryOffEditing ? (
                      <Counter
                        minValue={1}
                        onChange={handleSolarPanelCounter}
                        defaultValue={Number(solarProposalAdditionalDetails.numberOfPanels)}
                      />
                    ) : (
                      Number(solarProposalAdditionalDetails.numberOfPanels)
                    )}
                  </span>
                </li>
                <li className="flex flex-row justify-between items-center mb-[15px]">
                  <p className="text-[16px] leading-[24px] font-forma-djr-display-medium">
                    Energy consumption offset <br />
                  </p>
                  <span className="text-[18px] leading-[18px] font-forma-djr-display-medium">
                    {solarProposalAdditionalDetails.solarOffset}%
                  </span>
                </li>
                <li className="flex flex-row justify-between items-center mb-[15px]">
                  <p className="text-[15px] leading-[24px] font-forma-djr-display-medium">
                    Solar panels
                  </p>
                  <p className="text-[15px] leading-[24px] font-forma-djr-display-medium">
                    Canadian Solar 450 Watt
                  </p>
                </li>
                <li className="flex flex-row justify-between items-center mb-[15px]">
                  <p className="text-[15px] leading-[24px] font-forma-djr-display-medium">
                    Inverter
                  </p>
                  <p className="text-[15px] leading-[24px] font-forma-djr-display-medium">
                    Whole Home Hybrid Inverter
                  </p>
                </li>
                <li className="flex flex-row justify-between items-center mb-[15px]">
                  <p className="text-[15px] leading-[24px] font-forma-djr-display-medium">
                    Backup Battery
                  </p>
                  <p className="text-[15px] leading-[24px] font-forma-djr-display-medium">
                    20 kWh Backup Battery
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="sm:max-w-[60%] w-[96%] xl:ml-[32px] ml-[8px] mr-[8px]">
            <div className="mb-[20px] items-center rounded-[8px] border-[1px] border-solid border-primary_black gap-[55px] p-4 font-forma-djr-display-bold">
              <div>
                <h4 className="text-primary_black text-[32px] font-forma-djr-display-bold leading-normal mb-4 text-left font-bold">
                  A New, Powerful Energy Subscription
                </h4>
                <p className="text-[24px] leading-normal text-primary_black opacity-80 font-forma-djr-display-regular">
                  A Daylight energy subscription gives you more than monthly savings. It gives you
                  the confidence that your home will stay powered when the grid goes down, and the
                  freedom to take control of your home’s power.
                </p>
                <div>
                  <p className="mb-4 mt-8 text-[24px] font-bold text-primary leading-normal">
                    What You Get
                  </p>
                  <ul className="text-[24px] leading-normal opacity-80 space-y-2 font-bold text-gray-800">
                    {[
                      'Solar + battery system with $0 down',
                      'Power through outages and blackouts',
                      'App-based control and usage tracking',
                      '$100 bonus when you sign a proposal',
                      'Complete challenges and start earning rewards.'
                    ].map((text, index) => (
                      <li key={index} className="flex items-start gap-4">
                        ✅<span>{text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="mb-[20px] bg-tertiary p-4 rounded-[8px]">
              <h4 className="text-primary_black text-[32px] font-forma-djr-display-bold text-left">
                What’s Next
              </h4>
              <ul className="text-[24px] my-8 leading-normal opacity-80 space-y-2 font-bold font-forma-djr-display-bold text-gray-800">
                {[
                  'Send us your utility bill and we will create a custom energy proposal just for you.',
                  'Our team of experts will reach out to schedule a call to answer any questions and finalize the project details.',
                  'Sit back and relax; we will handle all the paperwork, permitting, and installation.',
                  'Enjoy up to 25% off your monthly utility bill and backup power when you need it.'
                ].map((text, index) => (
                  <li key={index} className="flex items-start gap-4">
                    <span className="w-[28px] h-[28px] shrink-0 rounded-full bg-primary text-[17px] text-white flex items-center justify-center mt-2">
                      {index + 1}
                    </span>
                    <span>{text}</span>
                  </li>
                ))}
              </ul>
              <div>
                <button
                  className="bg-primary w-full h-[48px] font-forma-djr-ui-bold px-4 text-white rounded-lg text-[15px] leading-6 border-[#F1D972] cursor-pointer disabled:cursor-not-allowed disabled:bg-neutral disabled:text-gray-500 hover:opacity-80"
                  onClick={handleScheduleConsultation}>
                  <span>Schedule a Consultation</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Proposal;
